$(document).ready(function() {

    /* manipuliere Powermail */
    $('.powermail_fancy-form, .powermail_form-footer, .powermail_landingpage-form, .powermail_lto-form, .powermail_ttg_ooeform').each(function(i) {
        var label = null;
        label = $(this).prevAll('label').html();

        if (label) {
            label = label.replace("*", " *");
            if ($(this).parent().hasClass('tx_powermail_pi1_fieldwrap_html_select')) {} else {
                $(this).attr('placeholder', label).attr('title', label);
                $(this).val(''); // Val retour setzen, sonst wird zb. Vorname mitübergen
            }
        }
    });

    $("#fancy-form,#form-footer,#landingpage-form,#lto-form, #ttg_ooeform").submit(function() {
        $(this).find("textarea").each(function() {
            if ($(this).val() == $(this).attr("title")) {
                $(this).addClass("invalid");
            }
        });
    });

    $('input.powermail_fancy-form,textarea.powermail_fancy-form,input.powermail_form-footer,textarea.powermail_form-footer, input.powermail_landingpage-form,textarea.powermail_landingpage-form,input.powermail_lto-form, textarea.powermail_lto-form,input.powermail_ttg_ooeform, textarea.powermail_ttg_ooeform').focus(function() {
        if ($(this).val() == $(this).attr('title')) {
            $(this).val('');
        }
    });

    // wenn Feld leer schreibe Standardwert danach wieder rein, damit man sich weiterhin auskennt was was ist
    $('input.powermail_fancy-form,textarea.powermail_fancy-form,input.powermail_form-footer,textarea.powermail_form-footer, input.powermail_landingpage-form,textarea.powermail_landingpage-form,input.powermail_lto-form, textarea.powermail_lto-form,input.powermail_ttg_ooeform, textarea.powermail_ttg_ooeform').blur(function() {
        if (!$(this).val()) {
            $(this).val($(this).attr('title'));
        }
    });

    //$('#form-footer').closest('.tx-powermail-pi1').appendTo('#footer_form');
    $('.tx-powermail-pi1_thx').find('p').each(function(i) {
        // entferne leere p-Tags
        if ($(this).html().length < 1) {
            $(this).remove();
        }

        // kürze lange Anfragen für korrekte Anzeige im Frame
        if ($(this).html().length > 350) {
            var length = 350; // set to the number of characters you want to keep
            var string = $(this).html();
            var trimmedString = string.substring(0, Math.min(length, string.length)) + " ...";
            $(this).html(trimmedString);
        }
    });

    $("#content-form").submit(function() {
        // Check Fields
        $('#content-form .required').each(function(i) {
            checkContentField($(this).attr('id'));
        });

        if (!$(this).find('a.checked').next('input').val()) {
            $(".nl-section").addClass("invalid");
        } else {
            $(".nl-section").removeClass("invalid");
        }

        if ($(this).find('.invalid').length) {
            return false;
        }

        if ($("input#titel").val() == $("input#titel").attr("title")) {
            $("input#titel").val("");
        }
    });

    // leere Eingabefeld wenn Standardwert
    $('#content-form input, #content-form textarea').focus(function() {
        if ($(this).val() == $(this).attr('title')) {
            $(this).val('');
        }
    });

    // fülle Eingabefeld mit Standardwert wenn keine Eingabe
    $('#content-form input, #content-form textarea').blur(function() {
        if (!$(this).val()) {
            $(this).val($(this).attr('title'));
        }
    });

    var language = $('html').attr('lang');
    if (language == 'de') {
        $('.tx_powermail_pi1_fieldwrap_html label').each(function() {
            var labelNeu = $(this).html().replace('*', '<abbr title="Pflichtfeld">*</abbr>');
            $(this).html(labelNeu);
        });
    }
    if (language == 'en') {
        $('.tx_powermail_pi1_fieldwrap_html label').each(function() {
            var labelNeu = $(this).html().replace('*', '<abbr title="mandatory field">*</abbr>');
            $(this).html(labelNeu);
        });
    }
    if (language == 'cz') {
        $('.tx_powermail_pi1_fieldwrap_html label').each(function() {
            var labelNeu = $(this).html().replace('*', '<abbr title="Povinné pole">*</abbr>');
            $(this).html(labelNeu);
        });
    }
    if (language == 'it') {
        $('.tx_powermail_pi1_fieldwrap_html label').each(function() {
            var labelNeu = $(this).html().replace('*', '<abbr title="Campo obbligatorio">*</abbr>');
            $(this).html(labelNeu);
        });
    }
    if (language == 'nl') {
        $('.tx_powermail_pi1_fieldwrap_html label').each(function() {
            var labelNeu = $(this).html().replace('*', '<abbr title="verplicht veld">*</abbr>');
            $(this).html(labelNeu);
        });
    }

    // Disable Powermail Submit Button after first click
    $('body').on('submit', 'form.powermail_form', function() {
        $(this).find('input[type="submit"]').attr('disabled', 'disabled');
    });

    // WOLFGANGSEE-574: mailto Verlinkung, welche direkt im Mail Client geöffnet werden soll
    $('#ttgRbContentWrapper').on('click', 'a[href^="mailto:"]', function(e) {
        if ($(this).hasClass('open-email-client')) {
            $('#ttgFancyTemplateWrapper').hide();
            $('.cc-window-backdrop').remove();
            var href = $(this).attr('href');
            window.location.href = href;
        }
    });

});

function checkContentField(id) {

    var value = $('#' + id).val(); // aktueller Wert
    var title = $('#' + id).attr('title'); // Standardwert

    // Check ob Standardwert oder leer >> ERROR
    if ((value == title) || !value) {

        $('#' + id).addClass('invalid');
        if ($('#' + id).attr('id') == "anrede" || $('#' + id).attr('id') == "land") {
            $('#' + id).next().addClass('invalid');
        }

    } else {

        // Spezieller Check für eMail Feld
        if (id == "email") {

            // Check auf korrekte eMail-Adresse
            var reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            if (reg.test(value)) {
                $('#' + id).removeClass('invalid'); // eMail-Adresse korrekt
            } else {
                $('#' + id).addClass('invalid'); // eMail-Adresse unkorrekt >> ERROR
            }

        } else {
            $('#' + id).removeClass('invalid');
            if ($('#' + id).attr('id') == "anrede" || $('#' + id).attr('id') == "land") {
                $('#' + id).next().removeClass('invalid');
            }
        }

    }

}